import React from "react";
import ReactDOM from "react-dom";
import "./icons";
import App from "./App";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "animate.css/animate.css";

ReactDOM.render(
  <BrowserRouter basename="/plataforma">
    <Switch>
      <Route render={props => <App {...props} />} />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
